/**
 * @route /licenses/details/:id/
 * @title Licenses::AofL Management System
 * @prerender false
 */
import styles from './template.css';
import template from './template';
import {storeInstance} from '@aofl/store/dist/legacy';
import translations from '../i18n';
import {AoflElement, customElement, property} from '@aofl/element';
import {sdoNs} from '../../../modules/constants-enumerate';
import {mapStatePropertiesMixin} from '@aofl/map-state-properties-mixin';
import {i18nMixin} from '@aofl/i18n-mixin';
import '../../../modules/sdo-licenses';
import '../../../modules/session-sdo';
import {routerInstance} from '@aofl/router';
import {ApiService} from '../../../modules/api-service';
import '../modules/modals';
import '../modules/inventory-allocation/sdo';

const DEFAULT_SEARCH = {
  field: 'group_name',
  query: ''
};
const DEFAULT_SORT = {
  fields: ['group_name', 'group_id'],
  direction: 'asc',
  limit: 10,
  is_forward: true
};

/**
 * @summary License Details
 * @extends {AoflElement}
 */
@customElement('license-details-element')
class LicenseDetails extends mapStatePropertiesMixin(i18nMixin(AoflElement)) {
  /**
   * Creates an instance of Licenses.
   */
  constructor() {
    super();
    this.translations = translations;
    this.storeInstance = storeInstance;
  }

  /**
   * @readonly
   */
  static get is() {
    return 'license-details-element';
  }

  @property({type: Boolean})
  loading = false;

  @property({type: Object})
  details = null;

  @property({type: Object, mapState: `${sdoNs.LICENSES}.$details`, store: storeInstance})
  licenseInfo = {};

  @property({type: Number, mapState: `${sdoNs.SESSION}.current_role.group_id`, store: storeInstance})
  currentGroupId = 0;

  @property({type: Object, mapState: `${sdoNs.LICENSES}.childGroupsLicenseCount`, store: storeInstance})
  childGroupsLicenseCount = {};


  static async loadData(licenseId, groupId) {
    const licenseInfo = await ApiService.licenseGetDetails(licenseId);
    storeInstance.commit({namespace: sdoNs.LICENSES, mutationId: 'setDetails', payload: licenseInfo});
    storeInstance.commit({namespace: sdoNs.LICENSE_INVENTORY_ALLOCATION, mutationId: 'setLoading', payload: true});
    this.childGroupsLicenseCount = licenseInfo.child_group_license_count;

    const state = storeInstance.getState();
    const gId = groupId || state[sdoNs.SESSION].current_role.group_id;
    const params = Object.assign({}, DEFAULT_SEARCH, {query: ''});

    const response = await ApiService.searchLicenseAllocations(params, {
      group_parent_id: gId,
      license_id: licenseId
    }, DEFAULT_SORT, false);
    const activeRow = Object.assign({}, {
      group_id: gId,
      group_name: state[sdoNs.SESSION].current_role.group_name,
      group_path: state[sdoNs.SESSION].group_info.path,
      license_id: licenseId
    }, licenseInfo.current_group_license_count);

    storeInstance.commit(
      {namespace: sdoNs.LICENSE_INVENTORY_ALLOCATION, mutationId: 'setLoading', payload: false},
      {namespace: sdoNs.LICENSE_INVENTORY_ALLOCATION, mutationId: 'setLicenseAllocations', payload: response.results},
      {namespace: sdoNs.LICENSE_INVENTORY_ALLOCATION, mutationId: 'setHasMore', payload: response.has_more},
      {namespace: sdoNs.LICENSE_INVENTORY_ALLOCATION, mutationId: 'setActiveRow', payload:activeRow},
      {namespace: sdoNs.LICENSE_INVENTORY_ALLOCATION, mutationId: 'setCurrentGroupLicenseCount', payload:licenseInfo.current_group_license_count},
      {namespace: sdoNs.LICENSE_INVENTORY_ALLOCATION, mutationId: 'setChildGroupLicenseCount', payload:licenseInfo.child_group_license_count},
    );
  }

  async connectedCallback() {
    super.connectedCallback();

    this.storeInstance.commit({
      namespace: sdoNs.LICENSES,
      mutationId: 'setLoadingDetails',
      payload: true
    });

    await LicenseDetails.loadData(parseInt(routerInstance.currentRoute.matchedRoute.props.id, 10));

    this.storeInstance.commit({
      namespace: sdoNs.LICENSES,
      mutationId: 'setLoadingDetails',
      payload: false
    });
  }

  scrollTo(event) {
    const id = event.detail.id;
    const el = this.shadowRoot.getElementById(id);
    if (!el) {
      return;
    }
    el.scrollIntoView({
      behavior: 'smooth'
    });
  }

  mapStateProperties() {
    const state = this.storeInstance.getState();
    this.loading = state[sdoNs.LICENSES].loadingDetails;
    this.details = state[sdoNs.LICENSES].details || {};
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render({
      default: {
        template,
        styles: [styles]
      }
    });
  }
}

export default LicenseDetails;
